module.exports = __webpack_public_path__ + "img/maptilburg.f8268295.png";